import { FC, useState } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import { css } from "@emotion/react";

interface Props {
  text?: string;
}

const GTextScramble: FC<Props & BaseProps> = (props) => {
  const [textValue, setTextValue] = useState(props.text);
  const styles = css``;
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  const mouseOverHandler = () => {
    let iterations = 0;
    const initialText = `${props.text}`;

    const interval = setInterval(() => {
      const ScrambledText = textValue
        ?.split("")
        .map((_letter, index) => {
          if (index < iterations) {
            return initialText[index];
          }

          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");
      setTextValue(ScrambledText);

      if (iterations >= initialText.length) clearInterval(interval);

      iterations += 1 / 3;
    }, 100);
  };

  return (
    <GText {...props}>
      <div
        data-value={props.text}
        onMouseOver={mouseOverHandler}
        id="g-text-scramble"
        css={styles}
      >
        {textValue}
      </div>
    </GText>
  );
};

GTextScramble.defaultProps = {
  text: "Grooody",
  color: "#000",
  once: true,
  fontSize: 50,
};

export default GTextScramble;

// We need to add the below in framer
/*
addPropertyControls(Button, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Inter",
    },
})
*/
